import React, { useState } from 'react';
import { useAuth } from '../../context/AuthContext';
import { useTheme } from '../../context/ThemeContext';
import styles from './Settings.module.css';

export default function Settings() {
  const { currentUser } = useAuth();
  const { theme, toggleTheme } = useTheme();
  const [storeName, setStoreName] = useState('متجري');
  const [saved, setSaved] = useState(false);

  const handleSave = (e) => {
    e.preventDefault();
    // ممكن هنا نحفظ البيانات في Firestore داخل collection settings
    setSaved(true);
    setTimeout(() => setSaved(false), 2000);
  };

  return (
    <div className={styles.page}>
      <div className={styles.header}>
        <h2>الإعدادات</h2>
        <p>تخصيص لوحة التحكم وحسابك</p>
      </div>

      <div className={styles.grid}>
        <div className={styles.card}>
          <h3>معلومات الحساب</h3>
          <div className={styles.infoRow}>
            <span>البريد الإلكتروني</span>
            <strong>{currentUser?.email}</strong>
          </div>
        </div>

        <div className={styles.card}>
          <h3>المظهر</h3>
          <div className={styles.themeRow}>
            <span>الوضع الليلي</span>
            <button
              className={`${styles.switch} ${theme === 'dark' ? styles.switchOn : ''}`}
              onClick={toggleTheme}
            >
              <span className={styles.switchDot} />
            </button>
          </div>
        </div>

        <div className={`${styles.card} ${styles.wide}`}>
          <h3>بيانات المتجر</h3>
          <form onSubmit={handleSave} className={styles.form}>
            <div className={styles.field}>
              <label>اسم المتجر</label>
              <input value={storeName} onChange={(e) => setStoreName(e.target.value)} />
            </div>
            <button type="submit" className={styles.saveBtn}>
              {saved ? 'تم الحفظ ✓' : 'حفظ التغييرات'}
            </button>
          </form>
        </div>
      </div>
    </div>
  );
}
